/* eslint-disable react/prop-types */ // TODO: add props
import style from './IndicatorCell.scss';
import cx from 'classnames';

export const INDICATOR_TYPES = {
  POSITIVE: 1,
  NEGATIVE: -1,
  NEUTRAL: 0,
};

export const IndicatorCell = ({ value, indicatorType }) => {
  if (!Object.values(INDICATOR_TYPES).includes(indicatorType)) {
    return null;
  }

  return (
    <span
      className={cx({
        [style.negativeCell]:
          value && indicatorType === INDICATOR_TYPES.NEGATIVE,
        [style.positiveCell]:
          value && indicatorType === INDICATOR_TYPES.POSITIVE,
        [style.neutralCell]: value && indicatorType === INDICATOR_TYPES.NEUTRAL,
      })}
      data-test="indicator-cell-value"
    >
      {value}
    </span>
  );
};
